import React from 'react';
import { img_path} from '../../../environment';

interface Image {
  className?: string;
  src: string;
  alt?: string;
  height?: number;
  width?: number;
  id?:string;
  style?:React.CSSProperties;
}

const ImageWithBasePath = (props: Image) => {
  // Combine the base path and the provided src to create the full image source URL
  const fullSrc = `${img_path}${props.src}`;
  return (
    <img
      className={props.className}
      src={fullSrc}
      height="30px"
      alt={props.alt}
      width="70px"
      id={props.id}
      style={props.style}
    />
  );
};

export default ImageWithBasePath;
